/* eslint-disable no-mixed-operators */
import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({

  buttonBack: {
    alignSelf: 'flex-end',
    
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  content: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },

  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },

  viewBase: {
    flex: 1,
  },
  textButton: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(6),
  },
  viewForm: {
    marginHorizontal: pixelDimensions(5),
  },

  input: {
    fontSize: pixelDimensions(4),
    width: '100%',
    backgroundColor: Colors.white,
    fontFamily: 'MMedium',
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(12),
    marginBottom: pixelDimensions(2),
    borderColor: Colors.grey500,
    borderWidth: 1,
  },
  inputIcon: {
    fontSize: pixelDimensions(5),
    position: 'absolute',
    color: Colors.grey700,
    top: pixelDimensions(3),
    left: pixelDimensions(3),
  },
  inputIconEye: {
    left: undefined,
    right: pixelDimensions(3),
  },
});

export default styles;
